import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=c52dc8ca&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=c52dc8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52dc8ca",
  null
  
)

export default component.exports